export const GOPHER_NEW_WINDOW_DAYS = 14;
export const GOPHER_DEEP_LINK_PARAM = 'gopher';
export const GOPHER_DEEP_LINK_VALUE = 'open';

const DEEP_LINK_STORAGE_KEY = 'box-os-gopher-open';
const DAY_MS = 24 * 60 * 60 * 1000;

function parseLaunch(launchDate: string | null | undefined): number | null {
  if (!launchDate) return null;
  const t = new Date(launchDate).getTime();
  return Number.isNaN(t) ? null : t;
}

export function hasGopherLaunched(
  launchDate: string | null | undefined,
  now: Date = new Date(),
): boolean {
  const t = parseLaunch(launchDate);
  return t !== null && now.getTime() >= t;
}

export function isGopherNewWindow(
  launchDate: string | null | undefined,
  now: Date = new Date(),
): boolean {
  const t = parseLaunch(launchDate);
  if (t === null) return false;
  const n = now.getTime();
  return n >= t && n < t + GOPHER_NEW_WINDOW_DAYS * DAY_MS;
}

export function hasGopherDeepLink(search: string): boolean {
  return (
    new URLSearchParams(search).get(GOPHER_DEEP_LINK_PARAM) ===
    GOPHER_DEEP_LINK_VALUE
  );
}

export function rememberGopherDeepLink(search: string): void {
  if (!hasGopherDeepLink(search)) return;
  try {
    sessionStorage.setItem(DEEP_LINK_STORAGE_KEY, '1');
  } catch {
    // storage unavailable
  }
}

export function consumeGopherDeepLink(): boolean {
  try {
    const v = sessionStorage.getItem(DEEP_LINK_STORAGE_KEY);
    if (v === null) return false;
    sessionStorage.removeItem(DEEP_LINK_STORAGE_KEY);
    return v === '1';
  } catch {
    return false;
  }
}
